import checkFF from '@webapp-next/lib/feature-flag';
import { isEnterprise } from '@/lib/company-subscription';

export const getIsDeaEnabled = (): boolean => {
  if (!checkFF('pre-4237-date-effective-agreement')) {
    return false;
  }
  if (!isEnterprise() && !checkFF('prf-256-new-ui-employee-pay-details')) {
    return false;
  }
  return true;
};
